import { render, staticRenderFns } from "./evaluacion-indicadores-estructura.vue?vue&type=template&id=cfad6e1a&"
import script from "./evaluacion-indicadores-estructura.vue?vue&type=script&lang=js&"
export * from "./evaluacion-indicadores-estructura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports